module.exports = __webpack_public_path__ + "static/media/vn.be36edc2.svg";